import Items from '../components/item'
import Loading from 'vue-loading-overlay'

export default {
  Items,
  Loading
}



// WEBPACK FOOTER //
// ./src/app/dweller/car/index/resources/components.js